module.exports = __webpack_public_path__ + "static/assets/e1c1595f09bbd039f7cabfe275e12a5f.png";